import type {Service} from "./types";

export const identityResourceOrder = [
  "users",
  "authorization_tokens",
] as const;

export const orderCatalogServices = (services: Service[]): Service[] => services.map(service => {
  const visibleResources = service.resources.filter(resource => resource.key !== "activity_logs");
  if (service.key !== "identity") return {...service, resources: visibleResources};

  const position = new Map<string, number>(identityResourceOrder.map((key, index) => [key, index]));
  const resources = visibleResources
    .map((resource, index) => ({resource, index}))
    .sort((left, right) => {
      const leftPosition = position.get(left.resource.key) ?? identityResourceOrder.length;
      const rightPosition = position.get(right.resource.key) ?? identityResourceOrder.length;
      return leftPosition - rightPosition || left.index - right.index;
    })
    .map(({resource}) => resource);

  return {...service, resources};
});
